import { useState } from 'react';
import { Group, Select, Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconDownload } from '@tabler/icons-react';
import { DateTime } from 'luxon';
import { AccountApi } from '../../AccountApi';

function buildMonthOptions(): { value: string; label: string }[] {
  const now = DateTime.utc().startOf('month');
  const options: { value: string; label: string }[] = [];
  for (let i = 0; i < 12; i++) {
    const month = now.minus({ months: i });
    options.push({
      value: String(i),
      label: `${month.monthLong} ${month.year}`,
    });
  }
  return options;
}

export function UsageExportButton() {
  const [monthOffset, setMonthOffset] = useState('0');
  const [isExporting, setIsExporting] = useState(false);

  async function handleExport() {
    setIsExporting(true);
    try {
      const now = DateTime.utc().startOf('month');
      const startDate = now.minus({ months: Number(monthOffset) });
      const endDate = startDate.plus({ months: 1 });

      const response = await AccountApi.getSubAccountStats(
        Math.floor(startDate.toSeconds()),
        Math.floor(endDate.toSeconds()),
      );

      const blob = new Blob([response.csvData], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = response.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      notifications.show({
        title: 'Export Failed',
        message: err instanceof Error ? err.message : 'Failed to export usage data.',
        color: 'red',
      });
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <Group gap="sm">
      <Select
        size="sm"
        data={buildMonthOptions()}
        value={monthOffset}
        onChange={(val) => val && setMonthOffset(val)}
        w={180}
        allowDeselect={false}
      />
      <Button
        size="sm"
        variant="light"
        leftSection={<IconDownload size={16} />}
        onClick={handleExport}
        loading={isExporting}
      >
        Export
      </Button>
    </Group>
  );
}
